<template>
  <div class="container-resizable">
    <div class="container-panel">
      <h2 class="title">
        {{ $t('messages.galleryTitle') }}
      </h2>

      <p class="parrafo">
        {{ $t('messages.galleryDescription') }}
      </p>

      <div class="boton-conocenos" @click="$router.push({ name: 'instalaciones' })">
        <i class="mdi mdi-chat-outline"></i> <span> {{ $t("messages.moreInformation") }} </span>
      </div>
      <div class="boton-conocenos" @click="$router.push({ name: 'registrate' })">
        <i class="mdi mdi-map-outline"></i> <span>{{ $t("messages.knowTheFacilities") }}</span>
      </div>
      <div class="boton-conocenos" @click="$router.push({ name: 'registrate' })">
        <i class="mdi mdi-calendar-month-outline"></i> <span>{{ $t("messages.iWantToReserveTheRooms") }}</span>
      </div>
    </div>
    <div class="container-panel">
      <GaleriaComponent :images="images" />
    </div>
  </div>
</template>

<script>
import GaleriaComponent from './galeria.vue'
export default {
  name: "GaleriaMain",
  components: {
    GaleriaComponent
  },
  data() {
    return {
      images: [
        {
          itemImageSrc: "./assets/layout/gallery/sala-cirugia-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-cirugia-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-1-t.jpg",
          texto: "messages.doctorsRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/esterilizacion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/esterilizacion-1-t.jpg",
          texto: "messages.steril",
        },
        {
          itemImageSrc: "./assets/layout/gallery/farmacia-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/farmacia-1-t.jpg",
          texto: "messages.pharmacy",
        },
        {
          itemImageSrc: "./assets/layout/gallery/cafeteria-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/cafeteria-1-t.jpg",
          texto: "messages.cafeteria",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recuperacion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recuperacion-1-t.jpg",
          texto: "messages.recoveryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/pasillo-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/pasillo-1-t.jpg",
          texto: "messages.recoveryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/vestier-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/vestier-1-t.jpg",
          texto: "messages.dressingRoom",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recepcion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recepcion-1-t.jpg",
          texto: "messages.reception",
        },
      ]
    }
  }
};
</script>

<style scoped>
.container-resizable {
  justify-content: center;
  background-color: #FFFFFF;
  padding-top: 15px;
  padding-bottom: 15px;
}

.container-panel {
  width: 50%;
  padding: 0px 20px;
}

.container-resizable .container-panel:first-child {
  text-align: center;
}

.title {
  font-weight: bolder;
  color: #083078;
  font-size: 40px;
  text-align: left;
}

.parrafo {
  color: #083078;
  font-size: 16px;
  line-height: 1.5;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
}

.boton-conocenos {
  background-color: #083078;
  color: #ffffff;
  padding: 9px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: fit-content;
  margin-bottom: 8px;
  transition: 0.5s all;
  cursor: pointer;
  user-select: none;
}

.boton-conocenos span {
  margin-left: 10px;
}

.boton-conocenos:hover {
  background-color: #2bb0d9;
}

@media screen and (max-width: 1850px) {
  .container-resizable {
    padding: 30px 30px;
  }
}

@media screen and (max-width: 1290px) {
  .container-resizable {
    padding: 30px 30px;
    flex-direction: column;
  }

  .container-panel {
    width: 100%;
  }
}

@media screen and (max-width: 880px) {
  .container-resizable {
    padding: 5px 5px;
    flex-direction: column;
  }
}
</style>
